// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-menu-item.active{pointer-events:none}`, "",{"version":3,"sources":["webpack://./../ZaddonsJSLibs/common-client2/src/components/v1/SidebarMenu/SidebarMenuItem.scss"],"names":[],"mappings":"AACI,0BACI,mBAAA","sourcesContent":[".sidebar-menu-item {\r\n    &.active {\r\n        pointer-events: none;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
